export function normalizeAccountList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.results)) return payload.data.results;
  return [];
}

export function accountIdsEqual(left, right) {
  if (left === null || left === undefined || left === '') return false;
  if (right === null || right === undefined || right === '') return false;
  return String(left) === String(right);
}

export function findAccountById(accounts, accountId) {
  if (!Array.isArray(accounts)) return null;
  return accounts.find((account) => accountIdsEqual(account?.id, accountId)) || null;
}

export function resolvePreferredAccountId(accounts, defaultAccountId) {
  const list = Array.isArray(accounts) ? accounts : [];
  if (list.length === 0) return '';

  const profileDefault = findAccountById(list, defaultAccountId);
  if (profileDefault) return profileDefault.id;

  const backendDefault = list.find((account) => Boolean(account?.is_default));
  if (backendDefault) return backendDefault.id;

  return list[0]?.id || '';
}

export function resolveInitialAccountId(accounts, currentAccountId, defaultAccountId, options = {}) {
  const list = Array.isArray(accounts) ? accounts : [];
  if (list.length === 0) return '';

  const current = findAccountById(list, currentAccountId);
  if (current && !options.preferDefault) return current.id;

  return resolvePreferredAccountId(list, defaultAccountId);
}

export function orderAccountsByPreferredDefault(accounts, defaultAccountId) {
  const list = Array.isArray(accounts) ? accounts : [];
  const preferredId = resolvePreferredAccountId(list, defaultAccountId);
  if (!preferredId) return [...list];

  return [...list].sort((left, right) => {
    const leftPreferred = accountIdsEqual(left?.id, preferredId);
    const rightPreferred = accountIdsEqual(right?.id, preferredId);
    if (leftPreferred === rightPreferred) return 0;
    return leftPreferred ? -1 : 1;
  });
}
